<template>
    <FormSection title="Comments" type="his-section" :full-height="false" :application-id="Number(application)">
        <template #content>
            <section class="d-flex flex-column px-3 py-2">
                <TemplateInput
                    :templates="templates"
                    :application="application"
                    :accountId="accountId"
                    :result="
                        referral.AdvancedDirectives.AdvancedDirectivesAdditionalComments
                            ? referral.AdvancedDirectives.AdvancedDirectivesAdditionalComments
                            : ''
                    "
                    v-on:resultUpdated="handleResultUpdated"
                />
                </section>
            </template>
    </FormSection>
</template>

<script lang="ts" src="./AdditionalComments.ts"></script>
